/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Button } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { SidebarTextField } from "~/components/SidebarForm/inputs/SidebarTextField";
import { SidebarForm } from "~/components/SidebarForm/SidebarForm";
import { SidebarFormButtons } from "~/components/SidebarForm/SidebarFormButtons";
import { showSuccess } from "~/components/Toast";
import { Tool } from "~/models";
import { ROUTES } from "~/routing";
import { generateActionSuccessText, useAxios } from "~/tools";

function ToolAdd() {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const methods = useForm();
  const { showError } = useShowError();
  const { Axios } = useAxios();
  const history = useHistory();

  const onSubmit = async (values: Tool) => {
    setIsSidebarOpen(false);
    try {
      const { data } = await Axios().post("/tools", { name: values.name });
      showSuccess(generateActionSuccessText(`Tool`)()("added")());
      history.push(`${ROUTES.tool.index}/${data.id}`);
    } catch (e) {
      showError(e.response);
    }
  };

  return (
    <>
      <Button
        onClick={() => setIsSidebarOpen(true)}
        css={{ marginLeft: "auto" }}
        icon="plus"
      >
        Add new Tool
      </Button>

      <SidebarForm
        title="Add Tool"
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        formMethods={methods}
        submit={onSubmit}
      >
        <SidebarTextField name="name" label="Name" required />
        <SidebarFormButtons
          submitEnabled={!!methods.watch("name")}
          onCancel={() => setIsSidebarOpen(false)}
        />
      </SidebarForm>
    </>
  );
}

export { ToolAdd };
